export default __webpack_public_path__ + "static/media/type-97.64ad3b69.svg";